module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_office-7d6fc16717efc85afad950e88ca941ef.svg";